import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface PanelToggleButtonProps {
  isMobile: boolean
  isExpanded: boolean
  mobileOpen: boolean
  onClick: () => void
}

function getToggleLabel(isMobile: boolean, isOpen: boolean): string {
  if (isMobile) return isOpen ? 'Close tools' : 'Open tools'

  return isOpen ? 'Collapse tools' : 'Expand tools'
}

/** The rail's top button: expands/collapses the Properties Panel (opens/closes it on mobile). */
export function PanelToggleButton({
  isMobile,
  isExpanded,
  mobileOpen,
  onClick,
}: PanelToggleButtonProps) {
  const isOpen = isMobile ? mobileOpen : isExpanded
  const label = getToggleLabel(isMobile, isOpen)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={onClick}
          className="data-[state=active]:bg-accent data-[state=active]:text-accent-foreground"
          data-state={mobileOpen || isExpanded ? 'active' : 'inactive'}
          aria-label={label}
        >
          {isOpen ? (
            <PanelLeftClose className="text-current" />
          ) : (
            <PanelLeftOpen className="text-current" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="right">{label}</TooltipContent>
    </Tooltip>
  )
}
